export {default} from "./productVendorBadge";
